import { BookingLink } from "./BookingLink";

export const CtaBand = () => (
  <section className="cta-band" aria-labelledby="final-title" data-testid="final-cta-section">
    <div className="container cta-band__grid">
      <div className="stack" data-reveal>
        <h2 id="final-title" className="cta-band__title">Find out in 30 minutes what your AI actually needs.</h2>
        <p className="cta-band__text">Bring the list of tools you already use. Leave knowing what is fine, what needs fixing, and what it would cost.</p>
      </div>
      <div className="cta-band__action" data-reveal>
        <BookingLink className="btn btn--xl btn--navy" testId="final-cta-book">Book a 30-min AI check</BookingLink>
        <p className="cta-band__note">Free, with no obligation to sign.</p>
      </div>
    </div>
  </section>
);
